import { useParams } from "react-router-dom";

import Box from "@/components/Box";
import { theme } from "@/core/theme";
import useDocTitle from "@/hooks/use-doc-title";
import Stack from "@/tpo/Stack";

import OrganisationOrderDetails from "./shared/OrganisationOrderDetails";

export default function OrganisationViewOrder() {
  // get the orderId url param and fetch the order
  useDocTitle("Order", false, "Regenerus");
  const { orderId } = useParams();

  return (
    <>
      {orderId && <OrganisationOrderDetails id={orderId} isModal={false} />}
    </>
  );
}
